import React, { useEffect, useContext } from 'react';

type ISLAction =
  | { type: 'SET_INIT_STATE'; payload: State }
  | { type: 'ADD_ITEM'; payload: any }
  | { type: 'UPDATE_ITEM'; payload: any }
  | { type: 'REMOVE_ITEM'; payload: any }
  | { type: 'SET_LIST_ID'; payload: string }
  | { type: 'SET_FILTER'; payload: any[] };

type Dispatch = (action: ISLAction) => void;
type State = {
  listId: any;
  listIdentifier: any;
  showListIdentifier: boolean;
  sortable: boolean;
  sortfilter_data: { headingText: any; sortFilters: any[] };
  sortfilter: any;
  arrItems: any[];
  isUserLoggedIn: boolean;
  currentFilter: any[];
  recaptcha: any;
  signinlink: string;
};
type CountProviderProps = { children: React.ReactNode };

// const CountStateContext = React.createContext<State | undefined>(undefined);
// const CountDispatchContext = React.createContext<Dispatch | undefined>(undefined);

const init = () => ({
  listId: null,
  listIdentifier: null,
  showListIdentifier: false,
  sortable: false,
  sortfilter_data: { headingText: null, sortFilters: [] },
  sortfilter: null,
  arrItems: [],
  currentFilter: [],
  isUserLoggedIn: false,
  recaptcha: null,
  signinlink: null
});

interface IShoppingListProvider {
  children?: React.ReactNode;
}

export const ShoppingListContext = React.createContext<{ state: State | undefined; dispatch: Dispatch }>(undefined);

function shoppinglistReducer(state: State, action: ISLAction): State {
  console.log(action);
  switch (action.type) {
    case 'SET_INIT_STATE': {
      return { ...state, ...action.payload };
    }
    case 'ADD_ITEM': {
      state.arrItems;
      return { ...state, arrItems: [action.payload, ...state.arrItems] };
    }
    case 'UPDATE_ITEM': {
      const arrItems = state.arrItems.map((i) => {
        if (i.itemId === action.payload.itemId) {
          i = action.payload;
        }
        return i;
      });
      return { ...state, arrItems };
    }

    case 'REMOVE_ITEM': {
      const arrItems = state.arrItems.filter((i) => !action.payload.itemIds.includes(i.itemId));
      return { ...state, arrItems };
    }

    case 'SET_FILTER': {
      return { ...state, currentFilter: action.payload };
    }

    case 'SET_LIST_ID': {
      return { ...state, listId: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const ShoppingListProvider: React.FC<IShoppingListProvider> = ({ children }) => {
  const [state, dispatch] = React.useReducer(shoppinglistReducer, init(), init);

  return <ShoppingListContext.Provider value={{ state, dispatch }}>{children}</ShoppingListContext.Provider>;
};
